import React, { useEffect, useRef, useState } from "react";
import "./SwiperButton.scss";

import { FaChevronLeft, FaChevronRight } from "react-icons/fa6";

const SwiperButton = ({ name, onComplete, color, type }) => {
  const sliderRef = useRef(null);
  const [position, setPosition] = useState(0);
  const [isDragging, setIsDragging] = useState(false);
  const [startX, setStartX] = useState(0);

  const [maxWidth, setMaxWidth] = useState(0);

  const [completed, setCompleted] = useState(false);

  const [colorPer, setColorPer] = useState(0);

  useEffect(() => {
    if (sliderRef && sliderRef.current) {
      if (sliderRef.current.clientWidth > 45)
        setMaxWidth(sliderRef.current.clientWidth - 45);
    }
  }, [sliderRef, window.clientWidth]);

  const handleMouseDown = (e) => {
    setIsDragging(true);

    const clientX = e.type === "touchstart" ? e.touches[0].clientX : e.clientX;
    setStartX(clientX - position);
  };

  const handleMouseMove = (e) => {
    if (!isDragging) return;
    const clientX = e.type === "touchmove" ? e.touches[0].clientX : e.clientX;
    const newX = clientX - startX;

    if (type === "right") {
      if (newX >= 0 && newX <= maxWidth) {
        setPosition(newX);
      }
    } else {
      if (newX <= 0 && newX >= -(maxWidth - 3)) {
        setPosition(newX);
      }
    }
  };

  const handleMouseUp = () => {
    setIsDragging(false);
    if (type === "right") {
      if (position > maxWidth / 2) {
        setPosition(maxWidth);
        if (!completed) {
          onComplete();
          setCompleted(true);
        }
        setTimeout(() => {
          setPosition(0);
        }, 500);
      } else {
        setPosition(0);
      }
    } else {
      if (position < -(maxWidth / 2)) {
        setPosition(-maxWidth);
        if (!completed) {
          onComplete();
          setCompleted(true);
        }
        setTimeout(() => {
          setPosition(0);
        }, 500);
      } else {
        setPosition(0);
      }
    }
  };

  useEffect(() => {
    setTimeout(() => {
      setCompleted(false);
    }, 600);
  }, [completed]);

  useEffect(() => {
    // Prevent division by zero and ensure colorPer is always a valid number
    const newColorPer = maxWidth > 0 ? Math.abs(position) / maxWidth : 0;
    setColorPer(newColorPer);
  }, [position, maxWidth]);

  return (
    <div
      className={`swipe-container ${color} ${type}`}
      onMouseMove={handleMouseMove}
      onMouseUp={handleMouseUp}
      onMouseLeave={handleMouseUp}
      onTouchMove={handleMouseMove}
      onTouchEnd={handleMouseUp}
      ref={sliderRef}
    >
      {type === "right" ? (
        <span
          className="arrow"
          style={{ transform: `translateX(${position}px)` }}
          onMouseDown={handleMouseDown}
          onTouchStart={handleMouseDown}
        >
          <FaChevronRight />
          <FaChevronRight className={`dark right`} />
        </span>
      ) : (
        <span
          className="arrow"
          style={{ transform: `translateX(${position}px)` }}
          onMouseDown={handleMouseDown}
          onTouchStart={handleMouseDown}
        >
          <FaChevronLeft className="dark" />
          <FaChevronLeft />
        </span>
      )}
      <span className="swipe-text">{name}</span>
      <div className="protector"></div>
      <div
        className={`background ${type}`}
        style={{ width: `${colorPer * 100}%`, opacity: colorPer || 0 }}
      ></div>
    </div>
  );
};

export default SwiperButton;
